import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Access as Access23 } from 'projects/flow-gui-access/views/2.3/access'
import { Access as Access24 } from 'projects/flow-gui-access/views/2.4/access'

class Access extends Component {
  render () {
    if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'accesses' && endpoint.version === '2.4').length !== 0) {
      return <Access24 {...this.props} />
    } else if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'accesses' && endpoint.version === '2.3').length !== 0) {
      return <Access23 {...this.props} />
    } else return false
  }
}
export default connect(state => state)(Access)



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/middlewares/access/access.js